<template>
  <div class="text-xs-center" style="background-color: #FFA726">
    <v-layout row>
      <v-flex xs1></v-flex>
      <v-flex v-for="(val, idx) in listMenu" :key="`2${idx}`" xs3>
        <v-menu offset-y>
          <template v-slot:activator="{ on }">
            <v-btn
              flat
              v-on="on"
              class="btnMenu"
            >
              {{ val.menuName }}
            </v-btn>
          </template>
          <v-list style="background-color: #FFA726">
            <v-list-tile
              v-for="(item, index) in val.subMenu"
              :key="index"
              :to="item.link"
            >
              <v-list-tile-title>{{ item.name }}</v-list-tile-title>
            </v-list-tile>
          </v-list>
        </v-menu>
      </v-flex>
    </v-layout>
  </div>
</template>

<script>
import { sync } from 'vuex-pathify'
export default {
  name: 'MenuNav',
  computed: {
    ...sync('*')
  },
  data () {
    return {
      maxList: 4,
      listMenu: []
    }
  },
  created () {
    this.listMenu = [
      {
        menuName: 'การออกรายงานสถิติอัตราการเพิ่มลด ในรอบ 10 ปี',
        linkMain: '',
        subMenu: [
          {
            name: '1. แสดงข้อมูลอัตราการเพิ่มลดของประชากร',
            link: '/ReportTenYear/1'
          },
          {
            name: '2. แสดงข้อมูลอัตราการเพิ่มลดของบุคคลไม่ได้สัญชาติไทย',
            link: '/ReportTenYear/2'
          },
          {
            name: '3. แสดงข้อมูลอัตราการเกิด',
            link: '/ReportTenYear/3'
          },
          {
            name: '4. แสดงข้อมูลอัตราการตาย',
            link: '/ReportTenYear/4'
          },
          {
            name: '5. แสดงข้อมูลอัตราการเกิดเปรียบเทียบกับอัตราการตายในรอบ 10 ปี',
            link: '/ReportTenYear/5'
          },
          {
            name: '6. แสดงข้อมูลอัตราการเกิดมากกว่าอัตราการตายในรอบ 10 ปี',
            link: '/ReportTenYear/6'
          },
          {
            name: '7. แสดงข้อมูลอัตราการเพิ่มลดของจำนวนบ้าน',
            link: '/ReportTenYear/7'
          },
          {
            name: '8. แสดงข้อมูลการออกบัตร',
            link: '/ReportTenYear/8'
          }
        ]
      },
      {
        menuName: 'สถิติ TOP TEN',
        linkMain: '',
        subMenu: [
          {
            name: '1. จังหวัดที่มีประชากร มากที่สุด 10 ลำดับ',
            link: '/ReportTopTen/1'
          },
          {
            name: '2. จังหวัดที่มีประชากร น้อยที่สุด 10 ลำดับ',
            link: '/ReportTopTen/2'
          },
          {
            name: '3. จังหวัดที่มีบุคคลไม่ได้สัญชาติไทย มากที่สุด 10 ลำดับ',
            link: '/ReportTopTen/3'
          },
          {
            name: '4. จังหวัดที่มีการเกิด มากที่สุด 10 ลำดับ',
            link: '/ReportTopTen/4'
          },
          {
            name: '5. จังหวัดที่มีการเกิด น้อยที่สุด 10 ลำดับ',
            link: '/ReportTopTen/5'
          },
          {
            name: '6. จังหวัดที่มีการตาย มากที่สุด 10 ลำดับ',
            link: '/ReportTopTen/6'
          },
          {
            name: '7. จังหวัดที่มีการตาย น้อยที่สุด 10 ลำดับ',
            link: '/ReportTopTen/7'
          },
          {
            name: '8. จังหวัดที่มีการแจ้งย้ายเข้า มากที่สุด 10 ลำดับ',
            link: '/ReportTopTen/8'
          },
          {
            name: '9. จังหวัดที่มีการแจ้งย้ายเข้า น้อยที่สุด 10 ลำดับ',
            link: '/ReportTopTen/9'
          },
          {
            name: '10. จังหวัดที่มีการแจ้งย้ายออก มากที่สุด 10 ลำดับ',
            link: '/ReportTopTen/10'
          },
          {
            name: '11. จังหวัดที่มีการแจ้งย้ายออก น้อยที่สุด 10 ลำดับ',
            link: '/ReportTopTen/11'
          }
        ]
      },
      {
        menuName: 'สถิติประชากรเลือกการจัดเรียง',
        linkMain: '',
        subMenu: [
          {
            name: '1. สถิติประชากร รายจังหวัด',
            link: '/ReportStat/1'
          },
          {
            name: '2. สถิติประชากร รายอำเภอ',
            link: '/ReportStat/2'
          },
          {
            name: '3. สถิติประชากร รายจังหวัด ตามช่วงอายุที่ระบุ',
            link: '/ReportStat/3'
          },
          {
            name: '4. สถิติอัตราการตายต่ออัตราการเกิด รายจังหวัด',
            link: '/ReportStat/4'
          },
          {
            name: '5. สถิติอัตราการแจ้งย้ายเข้าต่ออัตราการแจ้งย้ายออก รายจังหวัด',
            link: '/ReportStat/5'
          }
        ]
      }
    ]
  }
}
</script>

<style>
  .btnMenu {
    color: #000 !important;
    font-weight: bold !important;
    font-size: 16px !important;
  }
</style>
